import styled from 'styled-components'

const HeaderWrapper = styled.header` 
    background-color: ${(props) => props.theme.header.background};
    background-image: ${(props) => props.theme.header.backgroundImage};
    background-repeat: no-repeat;
    background-size: cover;
    &:hover: ${(props) => props.theme.header.hover};
    height: 50px;
    padding: 16px 0 15px;
    display: flex;
    align-items: center;
    position: relative;

    @media (min-width: 1024px) {
        height: 60px;
        padding: 32px 0 31px;
    }
`

export default HeaderWrapper
